/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IUser } from 'app/shared/model/user.model';

export interface IGlucoUser {
  id?: string;
  active?: boolean;
  age?: number | null;
  country?: string;
  customRangeMax?: number | null;
  customRangeMin?: number | null;
  typeOfDiabeties?: string;
  gender?: string;
  height?: number;
  microSec?: number;
  mobile?: string;
  name?: string;
  tmPassword?: string | null;
  preferredGlucoseUnit?: string;
  preferredLanguage?: string;
  preferredRange?: string;
  preferredUnitA1c?: string;
  preferredUnitWeight?: string;
  timestampentry?: number;
  parent?: boolean | null;
  dateOfBirth?: number | null;
  uuid?: string | null;
  bloodGroup?: string | null;
  lastupdated?: number;
  cursor?: number;
  imported?: boolean | null;
  deceased?: boolean | null;
  deceasedDate?: number | null;
  deceasedReason?: string | null;
  contactDetails?: IContactDetails | null;
  tmUser?: IUser;
}

export const defaultValue: Readonly<IGlucoUser> = {
  active: false,
  parent: false,
  imported: false,
  deceased: false,
};
